module.exports = "<section class=\"footer\">\n<p class=\"copy-rights\">copyright \t&copy; <a href=\"#\">bridge analyzers.inc</a>, 2019</p>\n\n</section>"


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/MileTrack-Frontend-AWS-S3/src/app/shared/components/footer/footer.component.html
// module id = ../../../../../src/app/shared/components/footer/footer.component.html
// module chunks = main